import React, { FC, useCallback, useMemo } from "react";
import { IconToggle, IJSXOption } from "@evergis/ui";
import { useTranslation } from "react-i18next";
import { useFetchParams } from "../../hooks/useFetchParams";

import { useFilter } from "../../hooks/useFilter";
import { getGeometryFilter, getServiceTypeFilter } from "../../../../ducks/catalog/selectors";
import { setGeometryFilter, setServiceTypeFilter } from "../../../../ducks/catalog/catalog";
import { FilterByServiceTypeContainer } from "./styled";

export const FilterByServiceType: FC = () => {
  const { t } = useTranslation("catalog");
  const [, updateGeometryFilter] = useFilter(getGeometryFilter, setGeometryFilter);
  const [, updateFilter] = useFilter(getServiceTypeFilter, setServiceTypeFilter);
  const { types } = useFetchParams();

  const filterOptions: IJSXOption[] = useMemo(
    () => [
      {
        value: "ProxyService",
        text: t("externalLayers"),
        icon: "externalservice",
      },
      {
        value: "RemoteTileService",
        text: t("remoteTileService"),
        icon: "tms",
      },
      {
        value: "LocalTileService",
        text: t("localTileService"),
        icon: "local_tile_service",
      },
    ],
    [t],
  );

  const onSelect = useCallback(
    value => {
      updateGeometryFilter("");
      updateFilter(types.includes(value) ? [] : [{ value }].map(type => type.value));
    },
    [types, updateGeometryFilter, updateFilter],
  );

  return (
    <FilterByServiceTypeContainer>
      {filterOptions.map(({ icon, text, value }) => (
        <IconToggle
          key={value}
          kind={icon}
          title={text as unknown as string}
          isSelected={types.includes(value)}
          onClick={() => onSelect(value)}
        />
      ))}
    </FilterByServiceTypeContainer>
  );
};
